import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";

const CancelDialog = ({
  type,
  edit,
  onConfirm,
  onCancel,
  handleClose,
  handleCancel,
}: {
  type: string;
  edit: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  handleClose: () => void;
  handleCancel: () => void;
}) => {
  const title = !edit
    ? `Cancel ${type} creation`
    : `Cancel ${type} modification`;

  const body = !edit
    ? `Are you sure you want to cancel the creation of the ${type}?`
    : `Are you sure you want to cancel the modification of the ${type}?`;

  const cancel = !edit
    ? `Cancel ${type} creation`
    : `Cancel ${type} modification`;

  return (
    <Dialog open={true} onClose={handleClose} className="globalCancellation">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ width: "445px" }}>{body}</DialogContent>
      <DialogActions sx={{ pb: 2, pr: 2 }}>
        <Button
          onClick={() => {
            onCancel?.();
            handleClose();
          }}
          color="primary"
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            onConfirm?.();
            handleCancel();
          }}
        >
          {cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
